// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "provider-service-line-summary #service-line-summary-table .spacer-column{width:1em;padding-left:1px;padding-right:1px;border:none;background-color:#fff}\n", ""]);
// Exports
module.exports = exports;
